define("ember-simple-auth/utils/inject", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _default;
  function _default(registry, factoryNameOrType, property, injectionName) {
    const inject = registry.inject || registry.injection;
    inject.call(registry, factoryNameOrType, property, injectionName);
  }
});